<template>
  <component
    :is="as"
    :class="cn(
      'inline-flex items-center justify-center rounded-none text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
      variants[variant],
      sizes[size],
      $attrs.class
    )"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>
import { cn } from "@/lib/utils";

export default {
  name: "UiButton",
  props: {
    variant: {
      type: String,
      default: "default",
    },
    size: {
      type: String,
      default: "default",
    },
    as: {
      type: String,
      default: "button",
    },
  },
  setup() {
    const variants = {
      default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
      destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
      outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline",
    };
    
    const sizes = {
      default: "h-9 px-4 py-2",
      sm: "h-8 rounded-none px-3 text-xs",
      lg: "h-10 rounded-none px-8",
      icon: "h-9 w-9",
    };

    return { cn, variants, sizes };
  },
};
</script>
